import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';

import { IHlsLevel } from '../hls/IHlsLevel';
import { IOnHlsLevelsChangedData } from '../hls/IOnHlsLevelsChangedData';

@Component({
	selector: 'hls-level-picker',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		@for (player of hlsLevelsModel.players; track $index) {
			<label class="label">
				{{ player.label }}

				<select
					class="select"
					(change)="onSelectChange($index)"
					[(ngModel)]="selectedLevels[$index]"
					ng-options="level as for level in player.levels">
					@for (level of player.levels; track levelsTrackByFunc($index, level)) {
						<option [ngValue]="level">
							{{ getLabelWithIndicator(level) }}
						</option>
					}
				</select>
			</label>
		}
	`,
	standalone: false,
	styleUrls: ['./HlsLevelPicker.Component.ng.less']
})
export class HlsLevelPickerComponent implements OnChanges {
	@Input() public hlsLevelsModel: IOnHlsLevelsChangedData;

	public selectedLevels: IHlsLevel[];

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.hlsLevelsModel && this.hlsLevelsModel) {
			this.selectedLevels = this.hlsLevelsModel.players
				.map(player => player.levels.find(level => level.isSelected));
		}
	}

	public getLabelWithIndicator(level: IHlsLevel): string {
		const indicator: string = level.isActive ? '*' : ' ';

		return indicator + level.label;
	}

	public levelsTrackByFunc(_index: number, level: IHlsLevel): number {
		return level.index;
	}

	public playersTrackByFunc(index: number): number {
		return index;
	}

	public onSelectChange(playerIndex: number): void {
		const selectedLevelIndex: number = this.selectedLevels[playerIndex].index;

		this.hlsLevelsModel.players[playerIndex].setLevel(selectedLevelIndex);
	}
}
